import { Select } from '@dynamika-shared/ui/Select/Select';
import { Switch } from '@dynamika-shared/ui/Switch/Switch';
import { useClinicalTrialInventorySlice } from '@restore/clinicalTrialInventory/clinicalTrialInventory.slice';
import { useMemo } from 'react';
import { WorkflowsSelect } from 'src/pages/ClinicalTrial/Readings/ReadingInventoryItemForm/components/WorkflowsSelect';
import { useInventoryFormHandler } from '@hooks/useInventoryFormHandler';
import { CodeEditor } from 'src/pages/ClinicalTrial/Readings/ReadingInventoryItemForm/CodeEditor';

export const Instrument = () => {
  const { onChange, watch } = useInventoryFormHandler();

  const [scoringForms] = useClinicalTrialInventorySlice((state, actions) => [
    state.scoringForms,
    actions,
  ]);

  const readersOptions = useMemo(() => {
    return scoringForms.map(scoringForm => ({
      label: scoringForm.name,
      value: scoringForm.id,
    }));
  }, [scoringForms]);

  return (
    <div className={' col-span-2'}>
      <div className={'flex justify-between'}>
        <div className={'grow min-w-[25%] me-4'}>
          <Select
            label={'Scoring Form'}
            placeholder={'Scoring Form'}
            listHeight={160}
            options={readersOptions}
            onChange={value => onChange('scoringFormId', value)}
            value={watch('scoringFormId')}
            data-testid='item-measurement'
          />
        </div>
        <div className={'min-w-[35%] me-4 flex gap-1 xl:flex-row flex-col'}>
          <Switch
            label={'For Imaging Specialist'}
            name={'For Imaging Specialist'}
            checked={watch('forImagingSpecialist')}
            onChange={e => onChange('forImagingSpecialist', e)}
            data-testid={'item-for-imaging-specialist'}
            className={'mt-2.5'}
          />
          <Switch
            label={'For Reader'}
            name={'For Reader'}
            checked={watch('forReader', true)}
            onChange={e => onChange('forReader', e)}
            data-testid={'item-for-reader'}
            className={'mt-2.5'}
          />
        </div>
        <CodeEditor
          classNameWrapper={'grow'}
          title={'Execution Config'}
          language={'json'}
          value={watch('executionConfig')}
          onChange={value => onChange('executionConfig', value)}
        />
      </div>
      <div className={'mt-3'}>
        <Switch
          label={'Runnable'}
          name={'Runnable'}
          checked={watch('runnable')}
          onChange={e => onChange('runnable', e)}
          data-testid={'item-runnable'}
          className={'mt-2.5'}
        />
      </div>
      <div className={'mt-3 flex justify-between gap-4 workflows'}>
        <WorkflowsSelect />
      </div>
    </div>
  );
};
